import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class Const extends Vue {
    protected BASE_URL: string = process.env.VUE_APP_BASE_URL as string
    protected ACS_URL: string = process.env.VUE_APP_ACS_URL as string
}
